export default __webpack_public_path__ + "static/media/up.0c5eb4d2.svg";